module.exports = __webpack_public_path__ + "static/img/1.6143201.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/1.png
// module id = NmDG
// module chunks = 0